// //Forgot Password Email sent notification
// import React from "react";
// import { MdEmail } from "react-icons/md";
// import Button from "@mui/material/Button";
// import { Link } from "react-router-dom";

// const EmailConfirmation = ({ email }) => {
//   const handleOpenEmailApp = () => {
//     window.open("https://mail.google.com", "_blank");
//   };
//   return (
//     <div className="grid grid-flow-row sm:grid-flow-col gap-0.5 font-inter min-h-screen relative" style={{
//       background: "linear-gradient(146deg, rgba(23,39,92,1) 9%, rgba(26,45,97,1) 24%, rgba(27,49,100,1) 33%, rgba(58,138,165,1) 100%)",
//       backgroundColor: "rgb(23,39,92)", 
//     }}>
//     <div className="sm:col-span-12 md:col-span-6 flex justify-center items-center text-3xl rounded-xl p-2"></div>

//       <div className="sm:col-span-6 flex justify-center items-center text-3xl p-2 border-l-2 relative" style={{ borderColor: "#214471" }}>
//         <div className="w-full flex justify-center items-center">
//           <div className="absolute inset-y-1/2 transform -translate-y-1/2 right-15 sm:right-25 w-2/3 bg-white rounded-lg h-2/3 flex flex-col justify-center items-center">
//             <div className="flex justify-center items-center w-1/3 h-1/3 bg-blue-950 rounded-full">
//               <MdEmail style={{ color: "white", fontSize: "4em" }} />
//             </div>
//             <div className="text-center mt-8">
//               <p className="text-xl font-semibold mb-3">Check your email</p>
//               <p className="text-base mx-20 mb-5">
//                 We have sent the password recover instructions to your email.
//                 <span
//                   style={{textDecoration: "underline" , color:"#17275C" }}
//                   className=" border-b-2  inline-block ml-2"
//                 >
//                   {email}
//                 </span>
//                 .
//               </p>
//             </div>
//             {/* <Button
//               variant="contained"
//               color="primary"
//               size="medium"
//               onClick={handleOpenEmailApp}
//               className="mt-20"
//               style={{
//                 color: "white",
//                 backgroundColor: "darkblue",
//                 fontWeight: "bold",
//                 padding: "8px 16px",
//               }}
//             >
//               Open Email App
//             </Button> */}

//             <Link to={"/"}>
//               <p className="text-gray-400 text-base mt-3">
//                 Skip, I'll Confirm Later
//               </p>
//             </Link>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EmailConfirmation;

import React from "react";
import { MdEmail } from "react-icons/md";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";

const EmailConfirmation = ({ email }) => {
  const handleOpenEmailApp = () => {
    window.open("https://mail.google.com", "_blank");
  };

  return (
    <div
      className='grid grid-cols-1 lg:grid-cols-2 min-h-screen font-inter'
      style={{
        background: 'linear-gradient(146deg, rgba(23,39,92,1) 9%, rgba(26,45,97,1) 24%, rgba(27,49,100,1) 33%, rgba(58,138,165,1) 100%)',
        backgroundColor: 'rgb(23,39,92)'
      }}>
      <div className='hidden lg:flex items-center justify-center text-3xl text-white p-4'>{/* Left content for larger screens */}</div>

      <div className='flex items-center justify-center px-6 py-8 lg:py-0 bg-red lg:border-l-2' style={{ borderColor: '#214471' }}>
          <div className="w-full flex justify-center items-center">
          <div className="w-11/12 sm:w-3/4 md:w-2/3 bg-white rounded-lg p-6 flex flex-col justify-center items-center shadow-lg">
            {/* Email Icon */}
            <div className="flex justify-center items-center w-20 h-20 sm:w-24 sm:h-24 bg-blue-950 rounded-full">
              <MdEmail className="text-white text-4xl sm:text-5xl" />
            </div>

            {/* Text Section */}
            <div className="text-center mt-6 sm:mt-8">
              <p className="text-lg sm:text-xl font-semibold mb-2">Check your email</p>
              <p className="text-sm sm:text-base px-4 md:px-6">
                We have sent the password recovery instructions to your email.
                <span
                  style={{ textDecoration: "underline", color: "#17275C" }}
                  className="ml-1"
                >
                  {email}
                </span>
              </p>
            </div>

            {/* Open Email App Button */}
            <Button
              variant="contained"
              color="primary"
              size="medium"
              onClick={handleOpenEmailApp}
              className="mt-6"
              sx={{ textTransform: "none" }}
              style={{
                color: "white",
                backgroundColor: "darkblue",
                fontWeight: "bold",
                padding: "8px 16px",
                marginTop:'16px'
              }}
            >
              Open Email App
            </Button>

            {/* Skip Link */}
            <Link to={"/"} className="mt-4">
              <p className="text-gray-500 text-sm sm:text-base">
                Skip, I'll Confirm Later
              </p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailConfirmation;
